import Button from '../../../../components/ui/Button';

import logo from '../../../../assets/images/logo-espn.svg';

import './Header.scss';

const Header = ({ title, button, image }) => {
    let headerStyle = {
        backgroundImage: `url(${image})`,
    };

    return (
        <header className="Header__Frontpage" style={headerStyle}>
            <div className="container--inner text--center">
                <img src={logo} alt="ESPN logo" />
                <h1 className="heading heading--large heading--white">
                    {title}
                </h1>
                {button && (
                    <Button
                        label={button.label}
                        link={button.link}
                        type="primary"
                        size="large"
                        align="center"
                    />
                )}
            </div>
        </header>
    );
};

export default Header;
